import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { Router } from "@angular/router";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { PrestadorModel } from "src/app/shared/models/prestador.model";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { ListItemSimplified } from "src/app/shared/models/ListItemSimplified.model";
import { EstadosSolicitud } from "src/app/shared/enumeraciones/estados-solicitud.enum";
import { SolicitudesService } from "../../../funcionario/solicitudes/solicitudes.service";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { AlertType } from "src/app/shared/models/alert.model";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { ModalAsignarSuspensionComponent } from "src/app/components/core/layouts/modal-asignar-suspension/modal-asignar-suspension.component";

@Component({
  selector: "app-suspension",
  templateUrl: "./suspension.component.html",
  styleUrls: ["./suspension.component.scss"],
})
export class SuspensionComponent implements OnInit {
  estados: Array<any>;
  descripcion: string;
  selectedStatusId: string;
  headers: Array<string>;
  modalGenerico: ModalGenericoModel;
  formDatos: FormGroup;
  formObservacion: FormGroup;
  estado_devuelto = EstadosSolicitud.Devuelto;
  datosRnt: Array<any> = [];
  @ViewChild("texto") texto: ElementRef;
  constructor(
    private formBuilder: FormBuilder,
    private solicitudServices: SolicitudesService,
    private modalService: NgbModal,
    private alertService: AlertsService
  ) {
    this.datosRnt = [];
  }

  ngOnInit() {
    this.formulario();
    this.headers = ["Número RNT", "Establecimiento", "Estado RNT", "Acciones"];
  }

  formulario() {
    this.formDatos = this.formBuilder.group({
      lista_rnt: ["", Validators.required],
    });

    this.formObservacion = this.formBuilder.group({
      observacion: ["", Validators.required],
    });
  }

  getRnt() {
    this.solicitudServices
      .getInformacionRnt(this.formDatos.value.lista_rnt)
      .subscribe((resultado) => {
        if (resultado.result) {
          const index = this.datosRnt
            .map(function (e) {
              return e.codigo_rnt;
            })
            .indexOf(resultado.data[0].codigo_rnt);
          if (index === -1) {
            this.datosRnt.push({ ...resultado.data[0] });
            this.formDatos.reset();
          } else {
            this.formDatos.reset();
          }
        }
      });
  }

  onEliminarRnt(item) {
    this.datosRnt.splice(this.datosRnt.indexOf(item), 1);
    if (this.datosRnt && this.datosRnt.length <= 0) {
      this.formObservacion.reset();
    }
  }

  confirm() {
    const modalRef = this.modalService.open(ModalAsignarSuspensionComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = true;
    modalRef.result.then((resultado) => {
      const modalRef = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        { centered: true }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message =
        resultado == 6
          ? `¿Está seguro de realizar la suspensión administrativa? Esta acción no se puede revertir`
          : `¿Está seguro de realizar la suspensión por autoridad competente? Esta acción no se puede revertir`;
      modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef.result.then(() => {
        let lista_rnt = "";
        this.datosRnt.forEach((item) => {
          lista_rnt += `${item.rnt_id},`;
        });
        // tslint:disable-next-line:max-line-length
        this.solicitudServices
          .sendSuspencionMasiva({
            lista_rnt,
            estado_rnt_id: resultado,
            tipo_solicitud_id: TipoSolicitud.Suspension,
            observacion: this.formObservacion.value.observacion.replace(
              new RegExp("\r?\n", "g"),
              "<br />"
            ),
            ...this.formObservacion.value,
          })
          .subscribe((result) => {
            if (result.result) {
              this.alertService.alert(
                result.control.alert_type as AlertType,
                "La solicitud fue enviada exitosamente.",
                `/Solicitud/${lista_rnt}`,
                result.control.code.toString(),
                true
              );
            }
            this.datosRnt = [];
            this.formObservacion.reset();
            this.formDatos.reset();
          });
      });
    });
  }
}
